/**
 * Fills the hidden tracking inputs rendered by a-tracking-attributes.liquid.
 *
 * Reads Meta's and GA4's own first-party cookies and writes them into the cart
 * form, so they are saved by the same request that proceeds to checkout and
 * end up on the order. The webhook handler reads them back to send Purchase
 * server side for this site, the same way it does for the five Hydrogen
 * storefronts.
 *
 * Values are refreshed on submit as well as on load, since a shopper can sit
 * on the cart long enough for the GA4 session to roll over.
 *
 * A missing value is normal and left blank. Direct traffic, non-Meta channels,
 * blocked cookies and ad blockers all legitimately produce orders without one.
 */
(function () {
  'use strict';

  /** Must match the measurement id the Google tag on this site reports to. */
  var GA4_MEASUREMENT_ID = 'G-4PPHLL5ED9';

  function readCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
    );
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]);
    } catch (error) {
      return match[1];
    }
  }

  /**
   * `_ga` reads `GA1.1.238945582.1790185048`. The client id is the last two
   * dot-separated parts, taken from the end so the other version and
   * domain-depth prefixes the tag emits still work.
   */
  function gaClientId() {
    var parts = readCookie('_ga').split('.');
    if (parts.length < 2) return '';
    var clientId = parts.slice(-2).join('.');
    return /^\d+\.\d+$/.test(clientId) ? clientId : '';
  }

  /**
   * `_ga_4PPHLL5ED9` reads `GS2.1.s1790185048$o1$g0$t1790185099$...`. The
   * session id follows `s` in the first `$` segment. The later `t` is the
   * last-activity time and a different number, so anchoring matters.
   */
  function gaSessionId() {
    var value = readCookie('_ga_' + GA4_MEASUREMENT_ID.replace(/^G-/, ''));
    var head = value.split('$')[0];
    var match = head && head.match(/s(\d+)$/);
    return match ? match[1] : '';
  }

  function currentValues() {
    return {
      // The Pixel's own cookies. Unlike the headless sites there is no
      // fallback to build here, since this site shares the checkout's domain
      // and the Pixel sets them directly.
      click_id: readCookie('_fbc'),
      browser_id: readCookie('_fbp'),
      ga_client_id: gaClientId(),
      ga_session_id: gaSessionId()
    };
  }

  /**
   * A GA4 session id is the session's start time in unix seconds, so the
   * value says how old it is. Past this, a carried-forward one is dead.
   *
   * GA4 ends a session after 30 minutes of inactivity but keeps the start
   * time as the id, so a long browse legitimately carries an id hours old.
   * A day is well past that and well short of the stale ids seen on real
   * orders, which were days out.
   */
  var SESSION_ID_MAX_AGE_SECONDS = 24 * 60 * 60;

  function isDeadSessionId(value) {
    if (!value || !/^\d+$/.test(value)) return false;
    return Date.now() / 1000 - Number(value) > SESSION_ID_MAX_AGE_SECONDS;
  }

  function fill() {
    var values = currentValues();
    var inputs = document.querySelectorAll('[data-tracking-attribute]');
    for (var i = 0; i < inputs.length; i += 1) {
      var input = inputs[i];
      var key = input.getAttribute('data-tracking-attribute');

      if (values[key]) {
        input.value = values[key];
        continue;
      }

      // Never blank a value the cart already holds. A cookie can disappear
      // between visits, and the earlier value is better than nothing.
      //
      // The exception is a session id the cart has outlived. A cart can sit
      // for days, and sending a session that closed days ago joins the
      // purchase to the wrong visit. That is worse than sending none: GA4 can
      // still attribute on the client id alone, but it cannot undo being
      // pointed at a dead session. Seen on a real order, six days out.
      if (key === 'ga_session_id' && isDeadSessionId(input.value)) {
        input.value = '';
      }
    }
  }

  function init() {
    fill();
    // Refresh at the last moment, and catch forms rendered after load such as
    // the cart drawer.
    document.addEventListener('submit', fill, true);
    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest('[name="checkout"]')) fill();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
